import { get } from 'lodash';
import { ILayerProps, LayerType } from '@/version-types';

// 递归是否全部为文本组（多选）
export const groupAllText = (layer: ILayerProps): boolean => {
    if (!layer) return false;
    if (layer.layerType === LayerType.GROUP_LAYER) {
        return layer.children.every((item) => groupAllText(item));
    } else if (layer.layerType === LayerType.TEXT_LAYER && !get(layer, 'data.shapeExtension', null)) {
        return true;
    }
    return false;
};

export const groupCanBatchWithSize = (
    layer: ILayerProps,
): { canBatch: boolean; size: { width: number | null; height: number | null } | null } => {
    if (!layer) return { canBatch: false, size: null };

    // 图片图层和矢量图层
    if (layer.layerType === LayerType.IMAGE_LAYER || layer.layerType === LayerType.VECTOR_LAYER) {
        return { canBatch: true, size: { width: layer.width, height: layer.height } };
    }

    // 分组图层
    if (layer.layerType === LayerType.GROUP_LAYER) {
        const childResults = (layer.children || []).map(groupCanBatchWithSize);

        // 如果存在非图片层
        if (childResults.some((r) => !r.canBatch)) {
            return { canBatch: false, size: null };
        }

        // 获取所有有效尺寸
        const sizes = childResults.map((r) => r.size).filter(Boolean) as { width: number; height: number }[];

        if (sizes.length === 0) return { canBatch: true, size: null };

        // 判断尺寸一致性
        const { width, height } = sizes[0];
        const widthSame = sizes.every((s) => s.width === width);
        const heightSame = sizes.every((s) => s.height === height);

        return { canBatch: true, size: { width: widthSame ? width : null, height: heightSame ? height : null } };
    }

    // 其他类型
    return { canBatch: false, size: null };
};
